// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZTgS","title":"styles_title__3r31y"};